import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

const AUTH = "auth";
const REGISTER = "register";
const LOGIN = "login";
const LOGOUT = "logout";
const CHANGE_PASSWORD = "changePassword";
const RESET_PASSWORD = "resetPassword";
const GET_ME = "getMe";

const MUTATION_KEYS = {
  [REGISTER]: [AUTH, REGISTER],
  [LOGIN]: [AUTH, LOGIN],
  [LOGOUT]: [AUTH, LOGOUT],
  [CHANGE_PASSWORD]: [AUTH, CHANGE_PASSWORD],
  [RESET_PASSWORD]: [AUTH, RESET_PASSWORD],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(AUTH, {
  [GET_ME]: null,
});

export {
  CHANGE_PASSWORD,
  GET_ME,
  LOGIN,
  LOGOUT,
  MUTATION_KEYS,
  QUERY_KEYS,
  REGISTER,
  RESET_PASSWORD,
};
